import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'react-hot-toast'
import App from './App.tsx'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <App />
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: 'var(--cosmic-dark)',
              color: 'var(--stellar-cyan)',
              border: '1px solid var(--stellar-blue)',
              boxShadow: '0 0 20px rgba(0, 212, 255, 0.2)',
            },
            success: {
              style: {
                background: 'var(--cosmic-dark)',
                color: 'var(--stellar-green)',
                border: '1px solid var(--stellar-green)',
                boxShadow: '0 0 20px var(--stellar-green)',
              },
            },
            error: {
              style: {
                background: 'var(--cosmic-dark)',
                color: 'var(--danger-red)',
                border: '1px solid var(--danger-red)',
                boxShadow: '0 0 20px var(--danger-red)',
              },
            },
          }}
        />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
) 